export const stripEmojis = (text: string): string => {
	const withoutEmojis = text.replace(/[\p{Emoji}\p{Cf}\p{Cc}]\s*/gu, '');
	// Remove any remaining special Unicode whitespace characters and variation selectors
	const withoutSpecialWhitespace = withoutEmojis.replace(/[\u200B-\u200D\uFEFF]|\uFE0F/g, '').trim();

	return withoutSpecialWhitespace;
};
